import { LAYER_HEIGHT_WITH_BORDER } from '~/constant'

export const getLayerIndexFromY = ({ y, topOffset, layersLength }) => {
  const layerIndex = Math.floor((y - topOffset) / LAYER_HEIGHT_WITH_BORDER)
  return Math.min(Math.max(layerIndex, 0), layersLength - 1)
}
